var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiberSmartRecord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 40C26.8366 40 34 32.8366 34 24C34 15.1634 26.8366 8 18 8C9.16344 8 2 15.1634 2 24C2 32.8366 9.16344 40 18 40Z",
    fill: "#FFF7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 11.1V11.46C34 12.2 34.46 12.84 35.14 13.16C39.2 15.08 42 19.22 42 24C42 28.78 39.2 32.92 35.14 34.84C34.46 35.16 34 35.78 34 36.52V36.88C34 38.24 35.42 39.1 36.64 38.52C42.16 36.02 46 30.46 46 24C46 17.54 42.16 11.98 36.64 9.45998C35.42 8.89998 34 9.73998 34 11.1Z",
    fill: "#FFF7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiberSmartRecord);
export default __webpack_public_path__ + "static/media/fiber-smart-record.108e10987aab5a43e6e1ebf4c7ba7924.svg";
export { ForwardRef as ReactComponent };